var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterMeterX24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24 12A12 12 0 1 1 12 0a12 12 0 0 1 12 12",
    fill: "#ff00b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.78 17.747s-2.207 3.147-2.22 4.4a.023.023 0 0 1-.007.013 2.224 2.224 0 1 0 4.447 0v-.013c-.02-1.253-2.22-4.4-2.22-4.4m1.56 4.407a.57.57 0 1 1-1.14 0v-.007a.57.57 0 1 1 1.14 0zm8.88-9.707v2.667h-1.9v.673h-1.84a7.032 7.032 0 0 1-4.367 4.587v-.714a6.333 6.333 0 1 0-4.667 0v.713a7.057 7.057 0 0 1-4.373-4.587h-1.84v-.673H2.34v-2.666h1.893v-.667h1.84a6.993 6.993 0 0 1 13.407 0h1.84v.667zm-15.775-.669h1.333v2.667H7.445zm3.667 2.667H9.778v-2.667h1.333zm2.333 0h-1.334v-2.667h1.333zm2.333 0h-1.333v-2.667h1.333zm2.333 0h-1.333v-2.667h1.333zm-7.667.917a1 1 0 1 1-1 1 1 1 0 0 1 1-1",
    transform: "translate(-.78 -2.26)",
    fill: "#f5f5f5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterMeterX24);
export default __webpack_public_path__ + "static/media/water-meter-x24.ab7960a7dcf21511501a744793c96cae.svg";
export { ForwardRef as ReactComponent };